import { z } from 'zod';
const HumanSchema = z.lazy(() => z.object({
    id: z.string().uuid(),
    name: z.string(),
    children: z.array(HumanSchema),
    parent: z.string().uuid().optional(),
}));
export { HumanSchema };
